<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<div class="tip">
					<div class="tip-left">
						(每月15日前申报上月全部个税，当前申报日期：{{ month }}月1日-{{
							month
						}}月15日)
						<div class="dan-tip">未在规定时间内缴纳则产生滞纳金</div>
					</div>
					<div class="tip-right"></div>
				</div>
				<el-row>
					<div class="flex-bw">
						<el-form :inline="true" :model="searchCondition">
							<el-form-item label="服务商">
								<el-select clearable v-model="searchCondition.channel_name">
									<el-option
										v-for="item in channelList"
										:key="item.value"
										:label="item.label"
										:value="item.label"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="缴纳状态">
								<el-select clearable v-model="searchCondition.pay_status">
									<el-option
										v-for="item in payStatusList"
										:key="item.value"
										:label="item.label"
										:value="item.value"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="申报状态">
								<el-select clearable v-model="searchCondition.declare_status">
									<el-option
										v-for="item in declareStatusList"
										:key="item.value"
										:label="item.label"
										:value="item.value"
									></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="时间">
								<el-date-picker
									:picker-options="{
										disabledDate,
									}"
									format="yyyy 年 MM 月"
									value-format="yyyyMM"
									v-model="searchCondition.month"
									type="month"
									placeholder="选择月"
								></el-date-picker>
							</el-form-item>
							<el-form-item>
								<el-button @click="searchButton" style="color: #1890ff"
									>查询</el-button
								>
							</el-form-item>
						</el-form>
					</div>
				</el-row>
				<el-row class="export-box">
					<div class="flex-bw">
						<div class="btn-box">
							<el-button @click="sbao" type="primary">一键申报</el-button>

							<el-button @click="zuofei" type="danger">作废</el-button>
							<el-button @click="jiaona" type="success">缴纳</el-button>
							<el-button @click="xiugai" type="warning">修改</el-button>
							<el-button @click="openAccount" type="primary">配置</el-button>
						</div>
						<div>
							<el-select
								v-model="value"
								placeholder="请选择导出类型"
								@change="selectData"
								class="select-box"
								size="medium"
							>
								<el-option
									v-for="item in options"
									:key="item.value"
									:label="item.label"
									:value="item.value"
								></el-option>
							</el-select>
							<el-button
								:loading="downloadLoading"
								style="margin: 0 0 20px 20px"
								type="primary"
								size="medium"
								icon="el-icon-document"
								@click="handleDownload"
							>
								导出
							</el-button>
							<el-button :loading="certificateLoading" type="primary" @click="downloadCertificate">下载完税证明</el-button>
							
						</div>
					</div>
				</el-row>
				<income />
				<ApeTable
					ref="apeTable"
					:data="companyList"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
					<el-table-column
						slot="first-column"
						align="left"
						prop="channel_name"
						label="服务商名称"
					>
						<template slot-scope="scope">
							<div class="name" @click="go_service(scope.row)">
								{{ scope.row.channel_name }}
							</div>
						</template>
					</el-table-column>
					<el-table-column
						width="120"
						header_align="center"
						align="center"
						label="申报状态"
					>
						<template slot-scope="scope">
							<span>
								{{ declareStatusTypeList[scope.row.declare_status] }}
							</span>
						</template>
					</el-table-column>
					<el-table-column
						width="120"
						header_align="center"
						align="center"
						label="缴纳状态"
					>
						<template slot-scope="scope">
							<span>
								{{ payStatusTypeList[scope.row.pay_status] }}
							</span>
						</template>
					</el-table-column>
					<el-table-column
						width="120"
						header_align="center"
						align="center"
						label="申报时间"
					>
						<template slot-scope="scope">
							<span>
								{{ scope.row.declare_time }}
							</span>
						</template>
					</el-table-column>
					<el-table-column
						width="80"
						header_align="center"
						align="center"
						label="操作"
					>
						<template slot-scope="scope">
							<span>
								<el-button
									size="mini"
									type="primary"
									@click="go_detail(scope.row)"
									>查看</el-button
								>
							</span>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>
	</div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import { mapGetters, mapState } from "vuex";
import ScreeCompany from "@/components/ScreeCompany.vue";
import MonthPicker from "@/components/MonthPicker.vue";
import moment from "moment";
import income from "./components/income.vue";
import { debounce } from "@/utils/utils.js";
const declareStatusTypeList = ["待申报", "申报中", "申报成功", "申报失败"];
const payStatusTypeList = ["待缴纳", "已缴纳"];
export default {
	components: {
		PageHeaderLayout,
		ApeTable,
		DatePicker,
		ScreeCompany,
		MonthPicker,
		income,
	},
	data() {
		return {
			debounce,
			defaultTime: "",
			month: "",
			dialogPdfArr: [],
			dialogMultPdf: false,
			checkList: ["选中且禁用", "复选框 A"],
			companyFormData: {
				category_id: [],
				name: [],
			},
			categoryList: [],
			channelList: [],
			// element的cascader的props值
			cascaderProps: {
				label: "display_name",
				value: "id",
			},
			searchCategory: [],
			// 搜索条件
			searchCondition: {
				month: "",
			},
			loadingStaus: true,
			payStatusTypeList,
			payStatusList: [
				{
					value: "0",
					label: "待缴纳",
				},
				{
					value: "1",
					label: "已缴纳",
				},
			],
			declareStatusTypeList,
			declareStatusList: [
				{
					value: "0",
					label: "待申报",
				},
				{
					value: "1",
					label: "申报中",
				},
				{
					value: "2",
					label: "申报成功",
				},
				{
					value: "3",
					label: "申报失败",
				},
			],
			// 允许显示的字段
			allowField: ["settlementId"],
			columns: [
				{
					title: "结算金额",
					value: "money",
					header_align: "center",
					align: "center",
					/*  width: 180 */
				},
				{
					title: "个税",
					value: "accumulate_tax_money",
					header_align: "center",
					align: "center",
					/*  width: 180 */
				},
				{
					title: "增值税",
					value: "added_tax_money",
					header_align: "center",
					align: "center",
					/*  width: 180 */
				},
			],
			// 表格列表数据
			companyList: [],
			// 分页信息
			pagingData: {
				is_show: true,
				layout: "total, sizes, prev, pager, next, jumper",
				total: 0,
			},
			// 分页的offset,序号列使用
			offset: 0,

			is_import: "",
			options: [
				{
					value: "xlsx",
					label: "xlsx",
				},
				{
					value: "csv",
					label: "csv",
				},
				{
					value: "txt",
					label: "txt",
				},
			],
			value: "xlsx",
			bookType: "xlsx", //导出表格类型
			downloadLoading: false,
			certificateLoading: false,
		};
	},

	computed: {
		...mapGetters(["userPermissions", "buttonType"]),
		...mapState({
			userInfo: (state) => state.userInfo,
		}),
	},
	watch: {
		"$route.matched": function(n, o) {
			console.log(o);
			if (n.length === 2) {
				this.init();
			}
		},
	},
	methods: {
		async downloadCertificate() {
			let params = this.checkTax();
			if (params === false) {
				return;
			}
			this.certificateLoading = true;
			try {
				let res = await this.$api.get_qxy_tax_certificate_list(params);
				if (!res) {
					this.$message.error('未获取到文件');
					return;
				}
				// 支持返回 Blob 或 URL 字符串
				if (res instanceof Blob) {
					const url = window.URL.createObjectURL(res);
					const a = document.createElement('a');
					const filename = `完税证明_${params.channel_name || '未知'}_${params.month || ''}.zip`;
					a.href = url;
					a.download = filename;
					document.body.appendChild(a);
					a.click();
					a.remove();
					window.URL.revokeObjectURL(url);
				} else {
					window.open(res, '_blank');
				}
				this.$message.success('下载已开始');
			} catch (error) {
				console.error('下载完税证明失败:', error);
				this.$message.error('下载完税证明失败');
			} finally {
				this.certificateLoading = false;
			}
		},
		checkTax() {
			let params = {
				month: this.searchCondition.month,
				channel_name: this.searchCondition.channel_name,
			};
			let tip = "";
			if (!params.month) {
				tip = "请选择时间";
			}
			if (!params.channel_name) {
				tip = "请选择服务商";
			}
			if (tip) {
				this.$message.error(tip);
				return false;
			}
			return params;
		},
		xiugai: debounce(async function() {
			let params = this.checkTax();
			if (params === false) {
				return;
			}

			await this.$api.get_qxy_declare_declare_update(params);
			this.$message.success("修改成功");
			this.init();
		}),
		zuofei: debounce(async function() {
			let params = this.checkTax();
			if (params === false) {
				return;
			}

			await this.$api.get_qxy_declare_declare_cancel(params);
			this.$message.success("作废成功");
			this.init();
		}),
		sbao: debounce(async function() {
			console.log("一键申报", this);
			let params = this.checkTax();
			if (params === false) {
				return;
			}

			await this.$api.get_qxy_declare_declare_submit(params);
			this.$message.success("申报成功");
			this.init();
		}),

		jiaona: debounce(async function() {
			let params = this.checkTax();
			if (params === false) {
				return;
			}
			params.channelName = params.channel_name;
			delete params.channel_name;
			const data = await this.$api.get_qxy_pay_tax_getUrl(params);
			if (data) {
				window.open(data);
			}
			console.log(data);
		}),
		go_service(row) {
			this.$router.push({
				path: "/individualServiceList",
				query: {
					channel_name: row.channel_name,
				},
			});
		},
		go_detail(row) {
			this.$router.push({
				path: "/individualTaxDetail",
				query: {
					channel_name: row.channel_name,
					id: row.id,
				},
			});
		},
		openAccount() {
			if (!this.searchCondition.channel_name) {
				this.$message.error("请选择服务商");
				return;
			}
			this.$router.push({
				path: "/individualOpenAccount",
				query: {
					company_name: this.searchCondition.channel_name,
				},
			});
		},

		//导出
		async handleDownload() {
			this.isExport = true;
			this.downloadLoading = true;
			let list = await this.init("export");
			import("@/excel/Export2Excel").then((excel) => {
				const tHeader = [
					"服务商名称",
					"结算金额",
					"个税",
					"增值税",
					"申报状态",
					"缴纳状态",
					"申报时间",
				];
				const data = this.formatJson(list);
				const time = new Date().getTime() + Math.random() * 1000;
				let filename = `申报数据${time}`;
				excel.export_json_to_excel({
					header: tHeader, //Header Required
					data, //Specific data Required
					filename: filename, //Optional
					autoWidth: true, //Optional
					bookType: this.bookType, //Optional
				});
				this.downloadLoading = false;
			});
		},
		//转换导出数据
		formatJson(jsonData) {
			return jsonData.map((v) => {
				let {
					channel_name,
					money,
					accumulate_tax_money,
					added_tax_money,
					declare_status,
					pay_status,
					declare_time,
				} = v;
				return [
					channel_name,
					money,
					accumulate_tax_money,
					added_tax_money,
					this.declareStatusTypeList[declare_status],
					this.payStatusTypeList[pay_status],
					declare_time,
				];
			});
		},
		//选择导出类型
		selectData(e) {
			this.bookType = e;
		},

		// 搜索
		searchButton() {
			this.init("search");
		},

		// 切换页码操作
		async switchPaging() {
			this.init();
		},

		// 初始化列表
		async init(type) {
			let pagingInfo = this.$refs["apeTable"]?.getPagingInfo(type) || {
				current_page: 1,
				page_size: 10,
			};
			if (type == "export") {
				pagingInfo.page_size = 50000;
				console.log(pagingInfo, "页面对象");
			} else {
				this.loadingStaus = true;
			}
			if (type == "search") {
				pagingInfo.current_page = 1;
			}
			let searchCondition = this.handleSearchCondition();
			Object.assign(searchCondition, pagingInfo);
			let { data, pages } = await this.$api.get_qxy_declare_channel_list(
				searchCondition
			);

			if (type == "export") {
				return data;
			} else {
				this.companyList = [];
				this.$nextTick(() => {
					this.companyList = data;
				});
				this.pagingData.total = pages.total;
				console.log(this.pagingData.total, "总数");
				this.offset = pages.offset;
				this.loadingStaus = false;
			}
		},
		// 处理搜索条件
		handleSearchCondition() {
			return this.searchCondition;
		},

		keyupSubmit() {
			document.onkeydown = (e) => {
				console.log(e);
				let _key = window.event.keyCode;
				if (_key === 13) {
					this.searchButton();
				}
			};
		},
		disabledDate(time) {
			return time.getTime() > Date.now();
		},
		async getAccountList() {
			let { items } = await this.$api.get_qxy_tax_get_account_list({
				current_page: 1,
				page_size: 1000000,
			});
			this.channelList = items.map((item) => {
				return {
					label: item.company_name,
					value: item.id,
				};
			});
		},
	},
	created() {
		this.keyupSubmit();
	},
	mounted() {
		this.getAccountList();
		this.month = moment().month() + 1;

		this.searchCondition.month = moment()
			.subtract(1, "M")
			.format("yyyyMM");
		console.log(this.defaultTime, typeof this.defaultTime);
		this.init();
	},
};
</script>

<style lang="scss" scoped>
::v-deep .el-row {
	margin-bottom: 0;
}
.tip {
	display: flex;
	justify-content: space-between;
	font-size: 16px;
	margin-bottom: 24px;
	.tip-left {
		display: flex;
	}

	.dan-tip {
		margin-left: 24px;
		color: #d9001b;
	}
}
.name {
	cursor: pointer;
	color: #409eff;
}
.flex-bw {
	display: flex;
	justify-content: space-between;
}
.btn-box {
	width: 360px;
	flex: none;
}
.table-right {
	float: right;
}
</style>
